/**
 * Top-Themen-Slider auf /buerger/.
 *
 * Ersetzt den alten Slick-Slider der Vor-Relaunch-Seite. Die Karten nutzen die
 * .highlight-card-Optik der übrigen Relaunch-Sektionen; Swiper übernimmt nur
 * das Scrollen samt Pfeil-Navigation.
 *
 * Swiper wird nur auf Startseite und /buerger/ enqueued (functions.php) —
 * ohne window.Swiper macht das Modul nichts und die CSS-Fallback-Regel
 * (.js-topthemen-slider:not(.swiper-initialized)) liefert ein scrollbares Rail.
 */

function initTopthemenSlider() {
  const container = document.querySelector(".js-topthemen-slider");
  if (!container) return;

  const root = container.closest(".buerger-section--topthemen");
  const prevEl = root ? root.querySelector(".js-topthemen-prev") : null;
  const nextEl = root ? root.querySelector(".js-topthemen-next") : null;
  const currentEl = root ? root.querySelector(".js-topthemen-current") : null;
  const progressEl = root ? root.querySelector(".js-topthemen-progress") : null;

  const updatePosition = (swiper) => {
    const current = swiper.activeIndex + 1;
    const total = swiper.slides.length;
    const slidesPerView =
      typeof swiper.params.slidesPerView === "number"
        ? Math.max(1, Math.floor(swiper.params.slidesPerView))
        : 1;
    const visibleThrough = Math.min(current + slidesPerView - 1, total);
    const visibleRange =
      visibleThrough > current ? `${current}–${visibleThrough}` : `${current}`;

    if (currentEl) currentEl.textContent = visibleRange;
    if (progressEl)
      progressEl.style.width = `${(visibleThrough / total) * 100}%`;
  };

  new window.Swiper(container, {
    slidesPerView: 1.08,
    spaceBetween: 18,
    watchOverflow: true,
    grabCursor: true,
    a11y: {
      containerMessage: "Top Themen",
      nextSlideMessage: "Nächstes Top-Thema",
      prevSlideMessage: "Vorheriges Top-Thema",
      slideLabelMessage: "{{index}} von {{slidesLength}}",
    },
    navigation:
      prevEl && nextEl
        ? {
            prevEl,
            nextEl,
            disabledClass: "is-disabled",
            lockClass: "is-locked",
          }
        : false,
    on: {
      init: updatePosition,
      slideChange: updatePosition,
      breakpoint: updatePosition,
    },
    breakpoints: {
      760: { slidesPerView: 2, spaceBetween: 24 },
      1120: { slidesPerView: 3, spaceBetween: 30 },
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof window.Swiper === "undefined") return;
  initTopthemenSlider();
});
